"use strict";
exports.__esModule = true;
exports.QuoteService = void 0;
var http_1 = require("../../core/http");
var quote_api_1 = require("./quote.api");
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var store_1 = require("./store");
var quote_helper_service_1 = require("./quote-helper.service");
var session_1 = require("../session");
var getQuote = function (sessionId) {
    store_1.QuoteStore.setLoading(true);
    return quote_helper_service_1.QuoteHelperService.fetchQuote(sessionId).pipe(operators_1.first(), operators_1.map(function (res) {
        store_1.QuoteStore.update(res);
        return res;
    }), operators_1.catchError(function (err) {
        console.log(err);
        return rxjs_1.of({});
    }), operators_1.finalize(function () { return store_1.QuoteStore.setLoading(false); }));
};
var createQuote = function (sessionId, body) {
    return http_1.Http.post(quote_api_1.QuoteApi.create(sessionId), body).pipe(operators_1.catchError(session_1.SessionService.shouldBeSessionError));
};
var resetCacheFetchQuote = function () { return quote_helper_service_1.QuoteHelperService.resetCacheFetchQuote(); };
exports.QuoteService = { getQuote: getQuote, createQuote: createQuote, resetCacheFetchQuote: resetCacheFetchQuote };
//# sourceMappingURL=quote.service.js.map